export default __webpack_public_path__ + "static/media/RubyAndDatabases.f300d674.png";